import { createStore } from './unistore/combined/react';
import { unistoreDevTools } from './unistore/devtools';
import addMemory from '../utils/addMemory';

import initialState from './initialState';

const store =
    process.env.NODE_ENV === 'production'
        ? createStore(initialState)
        : unistoreDevTools(createStore(initialState));

addMemory(store);

export default store;
